import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CtrlNavigationEntry, CtrlNavigationContext } from '../../shared/_models/models';
import { globalSearchConfig } from '../_services/unruly-navigation.config';
import { AuthenticationService } from '../../auth/_services/authentication.service';
import { WindowService } from '../../shared/_services/window.service';
import { Common } from '../../shared/_common/common.helper';
import { LayoutService } from '../_services/layout.service';
import { expandWidthAnimation } from '../_services/layout.animations';
@Component({
  selector: 'app-header-actions',
  templateUrl: './header-actions.component.html',
  styleUrls: ['./header-actions.component.less'],
  animations: [expandWidthAnimation]
})
export class HeaderActionsComponent implements OnInit {
  @Input() headerActions: CtrlNavigationEntry[];
  @Output() itemAction: EventEmitter<{ actionId: string; payload?: { context?: CtrlNavigationContext } }> = new EventEmitter();
  @ViewChild('profileMenu') profileMenuElement: ElementRef;
  searchItem: CtrlNavigationEntry = globalSearchConfig;
  displaySearchNavItem: boolean;

  constructor(
    private auth: AuthenticationService,
    private windowService: WindowService,
    private common: Common,
    public layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.displaySearchNavItem = !this.auth.currentUserValue.partnerId &&
      this.auth.isPassAllNavigationEntryAuthConfigCriteria(globalSearchConfig.rendererAuthConfig);
  }

  onItemAction(actionId: string): void {
    this.itemAction.emit({ actionId });
    if (actionId !== 'logoutAction') {
      this.closeProfileMenu();
    }
  }

  getSearchPlaceholder(): string {
    if (
      this.auth.currentUserValue?.roles &&
      this.auth.currentUserValue.roles.length === 1 &&
      this.auth.currentUserValue.roles[0] === 'Exchange Business Team'
    ) {
      return 'Search';
    }
    return `Search in ${this.layoutService.getContextTitle()}`;
  }

  onHelpCenterClick() {
    if (this.auth.currentUserValue.partnerId) {
      this.windowService.openWindow('https://nexxen-curated-marketplace.zendesk.com/hc/en-us', '_blank');
    } else {
      this.windowService.openWindow('https://unrulyssp-help.zendesk.com/', '_blank');
    }
    this.closeProfileMenu();
  }

  getRouterLinkPath(item: CtrlNavigationEntry): string[] {
    if (item?.actionId) {
      return null;
    } else if (item?.path) {
      return [`/${item.path?.join('/')}`];
    }
    return null;
  }


  getRouterLinkQueryParams(item: CtrlNavigationEntry): { [key: string]: string } {
    if (item?.path) {
      return {};
    }
    return this.common.toQueryParamsObject(location.search);
  }

  private closeProfileMenu(): void {
    const profileMenu = this.profileMenuElement?.nativeElement as HTMLElement & { hidePopover?: () => void };
    if (profileMenu && profileMenu.hidePopover) {
      profileMenu.hidePopover();
    }
  }

  onUpdateAvailableClick(): void {
    window.location.reload();
  }

}
